/* ── Ponva.nl Theme Scripts v3.2 ── */

(function() {
  'use strict';

  const fmtEUR = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' });
  window.dataLayer = window.dataLayer || [];
  const FB_MAP = { view_item: 'ViewContent', add_to_cart: 'AddToCart', begin_checkout: 'InitiateCheckout' };
  function dl(event, payload) {
    payload = payload || {};
    window.dataLayer.push(Object.assign({ event: event }, payload));
    try {
      if (typeof gtag === 'function') gtag('event', event, payload.ecommerce || {});
      if (typeof fbq === 'function' && FB_MAP[event]) {
        const ec = payload.ecommerce || {};
        fbq('track', FB_MAP[event], {
          currency: 'EUR',
          value: ec.value || undefined,
          content_ids: (ec.items || []).map(i => i.item_id),
          content_type: 'product'
        });
      }
    } catch (e) {}
  }

  const mobileToggle = document.querySelector('[data-mobile-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');
  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', () => {
      const isHidden = mobileNav.classList.contains('hidden');
      mobileNav.classList.toggle('hidden');
      mobileToggle.setAttribute('aria-expanded', isHidden ? 'true' : 'false');
    });
  }

  const cartBtns = document.querySelectorAll('[data-cart-toggle]');
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartOverlay = document.querySelector('[data-cart-overlay]');
  const cartClose = document.querySelector('[data-cart-close]');
  function openCart() { if (cartDrawer) cartDrawer.classList.add('open'); if (cartOverlay) cartOverlay.classList.add('open'); document.body.style.overflow = 'hidden'; }
  function closeCart() { if (cartDrawer) cartDrawer.classList.remove('open'); if (cartOverlay) cartOverlay.classList.remove('open'); document.body.style.overflow = ''; }
  cartBtns.forEach(btn => btn.addEventListener('click', openCart));
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  document.querySelectorAll('[data-quantity]').forEach(group => {
    const input = group.querySelector('input[type="number"]');
    const dec = group.querySelector('[data-qty-dec]');
    const inc = group.querySelector('[data-qty-inc]');
    if (!input) return;
    if (dec) dec.addEventListener('click', () => { input.value = Math.max(1, parseInt(input.value || 1) - 1); input.dispatchEvent(new Event('change')); });
    if (inc) inc.addEventListener('click', () => { input.value = parseInt(input.value || 1) + 1; input.dispatchEvent(new Event('change')); });
  });

  const dataEl = document.querySelector('[data-product-json]');
  if (dataEl) {
    let P;
    try { P = JSON.parse(dataEl.textContent); } catch (e) { P = null; }
    if (P) {
      const groups = Array.from(document.querySelectorAll('[data-option-group]'));
      const selected = [];
      groups.forEach((g, i) => {
        const active = g.querySelector('.option-pill.active');
        selected[i] = active ? active.getAttribute('data-option-value') : null;
      });

      const priceEl = document.querySelector('[data-price]');
      const priceSubEl = document.querySelector('[data-price-sub]');
      const variantInput = document.querySelector('[data-variant-id]');
      const qtyInput = document.querySelector('[data-qty]');
      const lineTotalEl = document.querySelector('[data-line-total]');
      const calcBox = document.querySelector('[data-m2-calc]');
      const m2Input = document.querySelector('[data-m2-input]');
      const m2Snij = document.querySelector('[data-m2-snij]');
      const m2Result = document.querySelector('[data-m2-result]');
      const atcBtn = document.querySelector('[data-atc-btn]');

      function findVariant() {
        return P.variants.find(v => {
          return (selected[0] == null || v.option1 === selected[0]) &&
                 (selected[1] == null || v.option2 === selected[1]) &&
                 (selected[2] == null || v.option3 === selected[2]);
        });
      }

      function pak(v) { return (P.pakinfo && v && P.pakinfo[v.sku]) || null; }

      function refresh() {
        const v = findVariant();
        if (!v) {
          if (atcBtn) { atcBtn.disabled = true; atcBtn.textContent = 'Combinatie niet beschikbaar'; }
          if (priceSubEl) priceSubEl.textContent = '';
          if (calcBox) calcBox.hidden = true;
          if (lineTotalEl) lineTotalEl.textContent = '';
          return;
        }
        if (atcBtn) { atcBtn.disabled = false; atcBtn.textContent = 'In winkelwagen'; }
        if (variantInput) variantInput.value = v.id;
        if (priceEl) priceEl.textContent = fmtEUR.format(v.price / 100);
        const info = pak(v);
        if (info && info.m2) {
          if (priceSubEl) priceSubEl.textContent = 'per pak van ' + String(info.m2).replace('.', ',') + ' m² · ' + fmtEUR.format(info.m2p) + ' per m²';
          if (calcBox) calcBox.hidden = false;
        } else if (info && info.staal) {
          if (priceSubEl) priceSubEl.textContent = 'per stuk (kleurstaal)';
          if (calcBox) calcBox.hidden = true;
        } else {
          if (priceSubEl) priceSubEl.textContent = '';
          if (calcBox) calcBox.hidden = true;
        }
        updateCalc();
        updateLineTotal();
      }

      function updateCalc() {
        if (!m2Input || !m2Result) return;
        const v = findVariant();
        const info = pak(v);
        const need = parseFloat((m2Input.value || '').replace(',', '.'));
        if (!info || !info.m2 || !need || need <= 0) { m2Result.textContent = ''; return; }
        const factor = (m2Snij && m2Snij.checked) ? 1.10 : 1.0;
        const packs = Math.ceil((need * factor) / info.m2);
        const totalM2 = packs * info.m2;
        const totalPrice = packs * v.price / 100;
        if (qtyInput) { qtyInput.value = packs; }
        m2Result.innerHTML = '<strong>' + packs + ' pakken</strong> = ' + totalM2.toFixed(2).replace('.', ',') + ' m² · totaal <strong>' + fmtEUR.format(totalPrice) + '</strong>';
        updateLineTotal();
      }

      function updateLineTotal() {
        if (!lineTotalEl || !qtyInput) return;
        const v = findVariant();
        if (!v) { lineTotalEl.textContent = ''; return; }
        const q = parseInt(qtyInput.value || 1);
        const info = pak(v);
        let txt = 'Totaal: ' + fmtEUR.format(q * v.price / 100);
        if (info && info.m2) txt += ' (' + (q * info.m2).toFixed(2).replace('.', ',') + ' m²)';
        lineTotalEl.textContent = txt;
      }

      groups.forEach((g, i) => {
        g.querySelectorAll('.option-pill').forEach(pill => {
          pill.addEventListener('click', () => {
            g.querySelectorAll('.option-pill').forEach(p2 => p2.classList.remove('active'));
            pill.classList.add('active');
            selected[i] = pill.getAttribute('data-option-value');
            const cur = g.querySelector('[data-option-current]');
            if (cur) cur.textContent = selected[i];
            refresh();
          });
        });
      });

      if (m2Input) m2Input.addEventListener('input', updateCalc);
      if (m2Snij) m2Snij.addEventListener('change', updateCalc);
      if (qtyInput) qtyInput.addEventListener('change', updateLineTotal);

      refresh();

      const v0 = findVariant();
      dl('view_item', { ecommerce: { currency: 'EUR', value: v0 ? v0.price / 100 : null, items: [{ item_id: v0 ? v0.sku : '', item_name: P.title, item_brand: P.vendor, price: v0 ? v0.price / 100 : null, quantity: 1 }] } });

      const form = document.getElementById('product-form');
      if (form) {
        form.addEventListener('submit', () => {
          const v = findVariant();
          const q = qtyInput ? parseInt(qtyInput.value || 1) : 1;
          dl('add_to_cart', { ecommerce: { currency: 'EUR', value: v ? v.price * q / 100 : null, items: [{ item_id: v ? v.sku : '', item_name: P.title, item_brand: P.vendor, price: v ? v.price / 100 : null, quantity: q }] } });
        });
      }
    }
  }

  document.querySelectorAll('a[href="/checkout"], a[href^="/checkout"]').forEach(a => {
    a.addEventListener('click', () => dl('begin_checkout', {}));
  });

  if ('IntersectionObserver' in window) {
    const imgObserver = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          if (img.dataset.src) { img.src = img.dataset.src; img.removeAttribute('data-src'); }
          img.classList.remove('lazy');
          obs.unobserve(img);
        }
      });
    }, { rootMargin: '200px' });
    document.querySelectorAll('img.lazy').forEach(img => imgObserver.observe(img));
  }

  document.querySelectorAll('[data-zoom]').forEach(img => {
    const container = img.parentElement;
    if (!container) return;
    container.style.overflow = 'hidden';
    img.addEventListener('mousemove', e => {
      const { left, top, width, height } = container.getBoundingClientRect();
      const x = ((e.clientX - left) / width) * 100;
      const y = ((e.clientY - top) / height) * 100;
      img.style.transformOrigin = x + '% ' + y + '%';
      img.style.transform = 'scale(1.5)';
    });
    img.addEventListener('mouseleave', () => { img.style.transform = 'scale(1)'; });
  });

  console.log('[Ponva] Theme v3.2 — brandbook 2026');
})();
